module.exports = __webpack_public_path__ + "static/media/close.4b5b71af.svg";